const COLORS = [
  '007BE7',
  '40A0F4',
  '645EFE',
  '5AB3FF',
  '4EC4FF',
  '4C00DC',
  '763EF4',
]

/**
 * Given a name, extracts initials and generates a fallback avatar url.
 */
export function generateAvatarFallback(
  name: string | null | undefined,
  color?: string,
) {
  if (!name) {
    return null
  }

  const initials = getInitials(name)
  color = color || COLORS[initials.charCodeAt(0) % COLORS.length]
  if (color?.startsWith('#')) {
    color = color.substring(1)
  }

  return `https://dummyimage.com/128/${color}/fff.png?text=+${initials}+`
}

function getInitials(str: string) {
  if (str.indexOf('@') > -1) {
    // It's an email, take the first and last part.
    const [, user, domain] = Array.from(/(.*?)@(.*)/.exec(str) || [])
    return `${user.charAt(0)}${domain.charAt(0)}`
  }

  const [first, last] = str.split(' ')
  if (!last) {
    return first.charAt(0)
  }

  return `${first.charAt(0)}${last.charAt(0)}`
}
